// extracted by extract-css-chunks-webpack-plugin
module.exports = {"charity":"charity_2fBP8","title":"title_2pgG_","part_wrap":"part_wrap_tP17Z","part_1":"part_1_C0yvx","content":"content_2PZyR","part_2":"part_2_2aw1d"};